module.exports = __webpack_public_path__ + "img/map2.dc944269.jpg";